import { Box, Divider, Typography } from "@mui/material";
const CustomDivider = ({ orientation = "horizontal", flexItem = false, sx = {}, size }) => {
  return (
    <Divider
      orientation={orientation}
      flexItem={flexItem}
      sx={{
        ...(orientation === "vertical"
          ? { width: size || { xs: "40px", lg: "70px" }, height: "auto" }
          : { height: size || { xs: "40px", lg: "70px" }, width: "auto" }),
        border: "none",
        ...sx,
      }}
    />
  );
};
export default CustomDivider;


export const OrDivider = ({ text }) => {
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Divider sx={{ flexGrow: 1, borderBottom: "0.5px solid #FFDBDB" }} />
      <Typography variant='body2' sx={{ mx: 1, color: "red.main" }}>{text}</Typography>
      <Divider sx={{ flexGrow: 1, borderBottom: "0.5px solid #FFDBDB" }} />
    </Box>
  )
}
